import { Button, Popover } from 'antd';
import { useLocation } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import Logoes from './Logoes';
import AboutFoxit from './AboutFoxit';
import { onOpenVr } from '&/utils/common';
import { getPackage } from '@/api/landingPage';
import QRCode from '&/assets/img/padLanding/appStoreQRCode.png';
import { imgDiff } from '&/utils/imgDiff';
import pcIcon from '@/assets/img/landing/intelligentDesign/pc-icon.png';
import mobileIcon from '@/assets/img/landing/intelligentDesign/mobile-icon.png';
import wsIcon from '@/assets/img/landing/intelligentDesign/ws-button.svg';
import renderImg from '@/assets/img/landing/intelligentDesign/render.png';
import chevronLeftIcon from '@/assets/img/landing/intelligentDesign/chevron-left@2x.png';
import chevronRightIcon from '@/assets/img/landing/intelligentDesign/chevron-right@2x.png';
// import { isBusiness } from '&/utils/common';
import './IntelligentDesign.scss';

export default inject('appStore')(
    observer(function LandingPage() {
        const { search } = useLocation();
        const OPEN_HDD_PARAM = new URLSearchParams(search).get('openHDD');

        function initDiff() {
            let rightIcon = document.createElement('img');
            rightIcon.src =
                require('@/assets/img/hdd/Icon-Caret-Right.png').default;
            let leftIcon = document.createElement('img');
            leftIcon.src =
                require('@/assets/img/hdd/Icon-Caret-Left.png').default;
            let iconWrap = document.createElement('div');
            iconWrap.className = 'diff-icon-wrap';
            iconWrap.appendChild(leftIcon);
            iconWrap.appendChild(rightIcon);

            new imgDiff('#diff-container').compare({
                animation: false,
                lineClassName: 'diff-line',
                arrowClassName: 'diff-dot',
                dotSlot: iconWrap,
            });
        }

        const [downloadUrl, setDownloadUrl] = useState();
        const [earlyVersionLink, setEarlyVersionLink] = useState();

        const openHDD = () => {
            document.ondragenter = function (e) {
                e.preventDefault();
            };
            document.ondragover = function (e) {
                e.preventDefault();
            };

            initDiff();

            // 安装包平台 1:hdd桌面端；2:安卓 3: ios
            getPackage({ from: 1 }).then(({ data }) => {
                setEarlyVersionLink(data.belowDownload);
                setDownloadUrl(data.upDownload?.downloadUrl);
            });

            if (!search.includes('openHDD')) return;
            window.location.href = 'FoxitHD.Document://' + OPEN_HDD_PARAM;
        };

        useEffect(openHDD, []);

        const HEADER_LIST = [
            {
                img: require('@/assets/img/landing/intelligentDesign/Icon_Gift2.png')
                    .default,
                title: intl.get('landingPage.intelligentDesign.message1'),
                subTitle: intl.get('landingPage.intelligentDesign.message2'),
            },
            {
                img: require('@/assets/img/landing/intelligentDesign/Icon2.png')
                    .default,
                title: intl.get('landingPage.intelligentDesign.message3'),
                subTitle: intl.get('landingPage.intelligentDesign.message4'),
            },
            {
                img: require('@/assets/img/landing/intelligentDesign/Icon3.png')
                    .default,
                title: intl.get('landingPage.intelligentDesign.message5'),
                subTitle: intl.get('landingPage.intelligentDesign.message6'),
            },
            {
                img: require('@/assets/img/landing/intelligentDesign/Icon4.png')
                    .default,
                title: intl.get('landingPage.intelligentDesign.message7'),
                subTitle: intl.get('landingPage.intelligentDesign.message8'),
            },
        ];
        const SESSION_ONE_LIST = [
            {
                img: require('@/assets/img/landing/intelligentDesign/bg_5.png')
                    .default,
                title: intl.get('landingPage.intelligentDesign.message9'),
                subTitle: intl.get('landingPage.intelligentDesign.message10'),
            },
            {
                img: require('@/assets/img/landing/intelligentDesign/bg_6.png')
                    .default,
                title: intl.get('landingPage.intelligentDesign.message11'),
                subTitle: intl.get('landingPage.intelligentDesign.message12'),
            },
            {
                img: require('@/assets/img/landing/intelligentDesign/bg_7.png')
                    .default,
                title: intl.get('landingPage.intelligentDesign.message13'),
                subTitle: intl.get('landingPage.intelligentDesign.message14'),
            },
            {
                img: require('@/assets/img/landing/intelligentDesign/bg_8.png')
                    .default,
                title: intl.get('landingPage.intelligentDesign.message15'),
                subTitle: intl.get('landingPage.intelligentDesign.message16'),
            },
        ];

        const FEATURE_LIST = [
            {
                img: require('@/assets/img/landing/intelligentDesign/lunbo/bg1.png')
                    .default,
                icon: [
                    {
                        img: require('@/assets/img/landing/intelligentDesign/lunbo/lunbo_1_icon_1.png')
                            .default,
                        text: intl.get('landingPage.intelligentDesign.wall'),
                    },
                    {
                        img: require('@/assets/img/landing/intelligentDesign/lunbo/lunbo_1_icon_2.png')
                            .default,
                        text: intl.get('landingPage.intelligentDesign.door'),
                    },
                    {
                        img: require('@/assets/img/landing/intelligentDesign/lunbo/lunbo_1_icon_3.png')
                            .default,
                        text: intl.get('landingPage.intelligentDesign.door'),
                    },
                    {
                        img: require('@/assets/img/landing/intelligentDesign/lunbo/lunbo_1_icon_4.png')
                            .default,
                        text: intl.get('landingPage.intelligentDesign.parts'),
                    },
                ],
                title: intl.get('landingPage.intelligentDesign.message17'),
                subTitle: [
                    // intl.get('landingPage.intelligentDesign.message17_1'),
                    intl.get('landingPage.intelligentDesign.message18'),
                    intl.get('landingPage.intelligentDesign.message19'),
                    intl.get('landingPage.intelligentDesign.message20'),
                ],
            },
            {
                img: require('@/assets/img/landing/intelligentDesign/lunbo/bg9.png')
                    .default,
                icon: [],
                title: intl.get('landingPage.intelligentDesign.message107'),
                subTitle: [
                    // intl.get('landingPage.intelligentDesign.message17_1'),
                    intl.get('landingPage.intelligentDesign.message108'),
                    intl.get('landingPage.intelligentDesign.message109'),
                ],
            },
            {
                img: require('@/assets/img/landing/intelligentDesign/lunbo/bg2.png')
                    .default,
                icon: [
                    {
                        img: require('@/assets/img/landing/intelligentDesign/lunbo/lunbo_2_icon_1.png')
                            .default,
                        text: intl.get(
                            'landingPage.intelligentDesign.message21'
                        ),
                    },
                    {
                        img: require('@/assets/img/landing/intelligentDesign/lunbo/lunbo_2_icon_2.png')
                            .default,
                        text: intl.get(
                            'landingPage.intelligentDesign.message22'
                        ),
                    },
                    {
                        img: require('@/assets/img/landing/intelligentDesign/lunbo/lunbo_2_icon_3.png')
                            .default,
                        text: intl.get(
                            'landingPage.intelligentDesign.message23'
                        ),
                    },
                ],
                title: intl.get('landingPage.intelligentDesign.message24'),
                subTitle: [
                    intl.get('landingPage.intelligentDesign.message25'),
                    intl.get('landingPage.intelligentDesign.message26'),
                    intl.get('landingPage.intelligentDesign.message27'),
                ],
            },

            {
                img: require('@/assets/img/landing/intelligentDesign/lunbo/bg3.png')
                    .default,
                icon: [
                    {
                        img: require('@/assets/img/landing/intelligentDesign/lunbo/lunbo_3_icon_1.png')
                            .default,
                        text: intl.get(
                            'landingPage.intelligentDesign.message77'
                        ),
                    },
                    {
                        img: require('@/assets/img/landing/intelligentDesign/lunbo/lunbo_3_icon_2.png')
                            .default,
                        text: intl.get(
                            'landingPage.intelligentDesign.message78'
                        ),
                    },
                ],
                title: intl.get('landingPage.intelligentDesign.message73'),
                subTitle: [
                    intl.get('landingPage.intelligentDesign.message74'),
                    intl.get('landingPage.intelligentDesign.message75'),
                    intl.get('landingPage.intelligentDesign.message76'),
                ],
            },
            {
                img: require('@/assets/img/landing/intelligentDesign/lunbo/bg8.png')
                    .default,
                title: intl.get('landingPage.intelligentDesign.message105'),
                subTitle: [
                    intl.get('landingPage.intelligentDesign.message100'),
                    intl.get('landingPage.intelligentDesign.message101'),
                    intl.get('landingPage.intelligentDesign.message102'),
                    intl.get('landingPage.intelligentDesign.message103'),
                ],
                linkText: intl.get('landingPage.intelligentDesign.message104'),
            },
            {
                img: require('@/assets/img/landing/intelligentDesign/lunbo/bg4.png')
                    .default,
                icon: [
                    {
                        img: require('@/assets/img/landing/intelligentDesign/lunbo/lunbo_4_icon_1.png')
                            .default,
                        text: intl.get(
                            'landingPage.intelligentDesign.message83'
                        ),
                    },
                    {
                        img: require('@/assets/img/landing/intelligentDesign/lunbo/lunbo_4_icon_2.png')
                            .default,
                        text: intl.get(
                            'landingPage.intelligentDesign.message84'
                        ),
                    },
                ],
                title: intl.get('landingPage.intelligentDesign.message79'),
                subTitle: [
                    intl.get('landingPage.intelligentDesign.message80'),
                    intl.get('landingPage.intelligentDesign.message81'),
                    intl.get('landingPage.intelligentDesign.message82'),
                    intl.get('landingPage.intelligentDesign.message82_1'),
                    intl.get('landingPage.intelligentDesign.message82_2'),
                ],
            },

            {
                img: require('@/assets/img/landing/intelligentDesign/lunbo/bg5.png')
                    .default,
                icon: [
                    {
                        img: require('@/assets/img/landing/intelligentDesign/lunbo/lunbo_5_icon_1.png')
                            .default,
                        text: intl.get(
                            'landingPage.intelligentDesign.message28'
                        ),
                    },
                    {
                        img: require('@/assets/img/landing/intelligentDesign/lunbo/lunbo_5_icon_2.png')
                            .default,
                        text: intl.get(
                            'landingPage.intelligentDesign.message29'
                        ),
                    },
                    {
                        img: require('@/assets/img/landing/intelligentDesign/lunbo/lunbo_5_icon_3.png')
                            .default,
                        text: intl.get(
                            'landingPage.intelligentDesign.message30'
                        ),
                    },
                ],
                title: intl.get('landingPage.intelligentDesign.message31'),
                subTitle: [
                    intl.get('landingPage.intelligentDesign.message32'),
                    intl.get('landingPage.intelligentDesign.message33'),
                    intl.get('landingPage.intelligentDesign.message34'),
                ],
            },
            {
                img: require('@/assets/img/landing/intelligentDesign/lunbo/bg6.png')
                    .default,
                icon: [
                    {
                        img: require('@/assets/img/landing/intelligentDesign/lunbo/lunbo_6_icon_1.png')
                            .default,
                        text: intl.get(
                            'landingPage.intelligentDesign.message35'
                        ),
                    },
                    {
                        img: require('@/assets/img/landing/intelligentDesign/lunbo/lunbo_6_icon_2.png')
                            .default,
                        text: intl.get(
                            'landingPage.intelligentDesign.message36'
                        ),
                    },
                ],
                title: intl.get('landingPage.intelligentDesign.message37'),
                subTitle: [
                    intl.get('landingPage.intelligentDesign.message38'),
                    intl.get('landingPage.intelligentDesign.message39'),
                    intl.get('landingPage.intelligentDesign.message40'),
                ],
            },
            {
                img: require('@/assets/img/landing/intelligentDesign/lunbo/bg7.png')
                    .default,
                icon: [
                    {
                        img: require('@/assets/img/landing/intelligentDesign/lunbo/lunbo_7_icon_1.png')
                            .default,
                        text: intl.get(
                            'landingPage.intelligentDesign.message41'
                        ),
                    },
                    {
                        img: require('@/assets/img/landing/intelligentDesign/lunbo/lunbo_7_icon_2.png')
                            .default,
                        text: intl.get(
                            'landingPage.intelligentDesign.message42'
                        ),
                    },
                    {
                        img: require('@/assets/img/landing/intelligentDesign/lunbo/lunbo_7_icon_3.png')
                            .default,
                        text: intl.get(
                            'landingPage.intelligentDesign.message43'
                        ),
                    },
                    {
                        img: require('@/assets/img/landing/intelligentDesign/lunbo/lunbo_7_icon_4.png')
                            .default,
                        text: intl.get(
                            'landingPage.intelligentDesign.message44'
                        ),
                    },
                ],
                title: intl.get('landingPage.intelligentDesign.message45'),
                subTitle: [
                    intl.get('landingPage.intelligentDesign.message46'),
                    intl.get('landingPage.intelligentDesign.message47'),
                    intl.get('landingPage.intelligentDesign.message48'),
                ],
            },
            {
                img: require('@/assets/img/landing/intelligentDesign/lunbo/bg10.png')
                    .default,
                icon: [],
                title: intl.get('landingPage.intelligentDesign.message110'),
                subTitle: [
                    intl.get('landingPage.intelligentDesign.message111'),
                    intl.get('landingPage.intelligentDesign.message112'),
                    intl.get('landingPage.intelligentDesign.message113'),
                ],
            },
        ];

        const [activeFeatureIndex, setActiveFeatureIndex] = useState(0);
        const [showTabScrollLeft, setShowTabScrollLeft] = useState(false);
        const [showTabScrollRight, setShowTabScrollRight] = useState(false);
        const featureTabListRef = useRef(null);
        const activeFeature = FEATURE_LIST[activeFeatureIndex];
        const SCROLL_EDGE_THRESHOLD = 2;
        const TAB_SCROLL_STEP = 132;

        const updateFeatureTabScrollState = () => {
            const el = featureTabListRef.current;
            if (!el) return;
            setShowTabScrollLeft(el.scrollLeft > SCROLL_EDGE_THRESHOLD);
            setShowTabScrollRight(
                el.scrollLeft + el.clientWidth <
                    el.scrollWidth - SCROLL_EDGE_THRESHOLD
            );
        };

        const scrollFeatureTabsLeft = () => {
            const el = featureTabListRef.current;
            if (!el || el.scrollLeft <= SCROLL_EDGE_THRESHOLD) return;
            el.scrollBy({
                left: -Math.min(el.scrollLeft, TAB_SCROLL_STEP),
                behavior: 'smooth',
            });
        };

        const scrollFeatureTabsRight = () => {
            const el = featureTabListRef.current;
            if (!el) return;
            const maxScrollLeft = el.scrollWidth - el.clientWidth;
            if (el.scrollLeft >= maxScrollLeft - SCROLL_EDGE_THRESHOLD) return;
            el.scrollBy({
                left: Math.min(maxScrollLeft - el.scrollLeft, TAB_SCROLL_STEP),
                behavior: 'smooth',
            });
        };

        useEffect(() => {
            const el = featureTabListRef.current;
            const activeBtn = el?.children[activeFeatureIndex];
            activeBtn?.scrollIntoView({
                behavior: 'smooth',
                inline: 'nearest',
                block: 'nearest',
            });
            requestAnimationFrame(updateFeatureTabScrollState);
        }, [activeFeatureIndex]);

        useEffect(() => {
            updateFeatureTabScrollState();
            window.addEventListener('resize', updateFeatureTabScrollState);
            return () =>
                window.removeEventListener(
                    'resize',
                    updateFeatureTabScrollState
                );
        }, []);

        const VR_LIST = [
            {
                img: require('@/assets/img/landing/intelligentDesign/image1.png')
                    .default,
                title: intl.get('landingPage.intelligentDesign.message92'),
                subTitle: [intl.get('landingPage.intelligentDesign.message93')],
            },
            {
                img: require('@/assets/img/landing/intelligentDesign/image2.png')
                    .default,
                title: intl.get('landingPage.intelligentDesign.message94'),
                subTitle: [intl.get('landingPage.intelligentDesign.message95')],
            },
            {
                img: require('@/assets/img/landing/intelligentDesign/image3.png')
                    .default,
                title: intl.get('landingPage.intelligentDesign.message96'),
                subTitle: [intl.get('landingPage.intelligentDesign.message97')],
            },
        ];

        const [currentType, setCurrentType] = useState('normal');

        const qrCodeEle = (
            <div className="popover-img-wrap">
                <div className="left-img">
                    <p className="qr-title">应用宝/App Store下载</p>
                    <img src={QRCode}></img>
                    <p>
                        华为/小米/OPPO应用商店，360&百度手机助手可搜索「福昕智装」下载
                    </p>
                </div>
            </div>
        );

        return (
            <div className="landing-intelligentDesign">
                <div className="header">
                    <div className="header-flex">
                        <div className="flex-wrap">
                            <div className="head-content">
                                <div className="large-title">
                                    {intl.get(
                                        'landingPage.intelligentDesign.message49'
                                    )}
                                    <span className="dot"></span>
                                    {intl.get(
                                        'landingPage.intelligentDesign.message50'
                                    )}
                                </div>
                                <div className="line"></div>
                                <div className="sub-title">
                                    {intl.get(
                                        'landingPage.intelligentDesign.message51'
                                    )}
                                </div>
                                <div className="small-title">
                                    {intl.get(
                                        'landingPage.intelligentDesign.message52'
                                    )}
                                </div>
                                <div className="download-button-group">
                                    <a href={downloadUrl} download>
                                        <Button
                                            type="default"
                                            shape="round"
                                            size={'large'}
                                            className="btn-item pc">
                                            <img
                                                src={pcIcon}
                                                className="item-icon"></img>
                                            <div>
                                                <div className="btn-title">
                                                    智能设计
                                                </div>
                                                <div className="btn-subtitle">
                                                    Windows
                                                </div>
                                            </div>
                                        </Button>
                                    </a>
                                    <div className="btn-ws">
                                        <a
                                            href="https://apps.microsoft.com/store/detail/XP9M9N2Q526S3J"
                                            target="_blank"
                                            rel="noreferrer">
                                            <img src={wsIcon}></img>
                                        </a>
                                    </div>
                                    <Popover
                                        content={qrCodeEle}
                                        trigger="hover"
                                        placement="bottom">
                                        <Button
                                            type="primary"
                                            shape="round"
                                            size="large"
                                            className="btn-item app">
                                            <img
                                                src={mobileIcon}
                                                className="item-icon"></img>
                                            <div>
                                                <div className="btn-title">
                                                    福昕智装
                                                </div>
                                                <div className="btn-subtitle">
                                                    iOS/Android
                                                </div>
                                            </div>
                                        </Button>
                                    </Popover>
                                </div>
                                {/* <div className="version">
                                    {intl.get(
                                        'landingPage.intelligentDesign.version'
                                    )}
                                    ：{version}
                                </div> */}
                                {earlyVersionLink && (
                                    <a
                                        className="download-beta"
                                        href={earlyVersionLink.downloadUrl}
                                        download>
                                        <i className="filled icon-chevro-down"></i>
                                        <span>
                                            {earlyVersionLink.trialTitle}
                                        </span>
                                    </a>
                                )}
                            </div>
                        </div>
                        <div className="flex-right-wrap">
                            <div
                                className="threeD-preview-btn"
                                onClick={() =>
                                    window.open(
                                        '/design/preview?from=landingPage'
                                    )
                                }>
                                <span>3D预览</span>
                            </div>
                            <img
                                src={
                                    require('@/assets/img/landing/intelligentDesign/head-right.png')
                                        .default
                                }></img>
                        </div>
                    </div>
                    <div className="sub-box-wrap">
                        <div className="flex-box">
                            {HEADER_LIST.map((v, index) => {
                                return (
                                    <div className="box" key={index}>
                                        <img src={v.img}></img>
                                        <div className="content">
                                            <div className="title">
                                                <div
                                                    style={{ display: 'none' }}>
                                                    {intl.get(
                                                        'landingPage.intelligentDesign.message54'
                                                    )}
                                                </div>
                                                {v.title}
                                            </div>
                                            <div className="sub-title">
                                                <div
                                                    style={{ display: 'none' }}>
                                                    {intl.get(
                                                        'landingPage.intelligentDesign.message55'
                                                    )}
                                                </div>
                                                {v.subTitle}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <div className="section-three">
                    <div className="sub-content">
                        <div className="large-title">
                            {intl.get(
                                'landingPage.intelligentDesign.message85'
                            )}
                        </div>
                        <div className="sub-title">
                            {intl.get(
                                'landingPage.intelligentDesign.message86'
                            )}
                        </div>

                        <div className="vr-normal-preview">
                            <div className="left-btn">
                                <div
                                    className={`normal-picture btn ${
                                        currentType === 'normal' ? 'active' : ''
                                    }`}
                                    onClick={() => setCurrentType('normal')}>
                                    {' '}
                                    {intl.get(
                                        'landingPage.intelligentDesign.message87'
                                    )}
                                </div>
                                <div
                                    className={`normal-picture btn ${
                                        currentType === 'vr' ? 'active' : ''
                                    }`}
                                    onClick={() => setCurrentType('vr')}>
                                    {intl.get(
                                        'landingPage.intelligentDesign.message88'
                                    )}
                                </div>
                                <div className="line">
                                    <div
                                        className={`circle ${
                                            currentType === 'normal'
                                                ? 'active'
                                                : ''
                                        }`}></div>
                                    <div
                                        className={`circle ${
                                            currentType === 'vr' ? 'active' : ''
                                        }`}></div>
                                </div>
                            </div>
                            <div className="right-content">
                                <div className="right-content-wrap">
                                    <div
                                        className="right-content-item-1"
                                        id="diff-container"
                                        style={{
                                            visibility:
                                                currentType === 'vr'
                                                    ? 'hidden'
                                                    : 'visible',
                                        }}>
                                        <img
                                            // className="image-preview"
                                            data-caption="After"
                                            src={
                                                require('@/assets/img/landing/intelligentDesign/normal-picture.png')
                                                    .default
                                            }
                                            style={{
                                                zIndex:
                                                    currentType === 'normal'
                                                        ? 2
                                                        : 1,
                                            }}></img>
                                        <img
                                            data-caption="Before"
                                            // className='image-preview'
                                            style={{
                                                zIndex:
                                                    currentType === 'normal'
                                                        ? 2
                                                        : 1,
                                            }}
                                            src={
                                                require('@/assets/img/landing/intelligentDesign/normal-picture-1.png')
                                                    .default
                                            }></img>
                                    </div>
                                    <div
                                        className="right-content-item-2"
                                        style={{
                                            visibility:
                                                currentType === 'vr'
                                                    ? 'visible'
                                                    : 'hidden',
                                        }}>
                                        {/* <div className="image-preview-wrap"> */}
                                        <img
                                            className="image-preview"
                                            src={
                                                require('@/assets/img/landing/intelligentDesign/vr-picture.png')
                                                    .default
                                            }
                                            onClick={
                                                currentType === 'vr'
                                                    ? () => onOpenVr()
                                                    : () => {}
                                            }></img>
                                        <div
                                            className="tip"
                                            onClick={
                                                currentType === 'vr'
                                                    ? () => onOpenVr()
                                                    : () => {}
                                            }>
                                            <img
                                                src={
                                                    require('@/assets/img/landing/intelligentDesign/vr-tip.png')
                                                        .default
                                                }></img>
                                            <div className="title">
                                                {intl.get(
                                                    'landingPage.intelligentDesign.message89'
                                                )}
                                            </div>
                                        </div>
                                        {/* </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="large-title large-title-1">
                            {intl.get(
                                'landingPage.intelligentDesign.message90'
                            )}
                        </div>
                        <div className="sub-title">
                            {intl.get(
                                'landingPage.intelligentDesign.message91'
                            )}
                        </div>

                        <div className="vr-preview-sub">
                            {VR_LIST.map((v, index) => (
                                <div className="vr-preview-item" key={index}>
                                    <img src={v.img}></img>
                                    <div className="content">
                                        <div className="title">{v.title}</div>
                                        <div className="sub-title">
                                            {v.subTitle}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="offline-render">
                            <div className="left-content">
                                <div className="title">离线渲染</div>
                                <div className="description">
                                    实时预览场景中的渲染效果，所见即所得，提升布光效率
                                </div>
                            </div>
                            <div className="right-image">
                                <img src={renderImg} alt="离线渲染" />
                            </div>
                        </div>
                        <div
                            className="operate-btn"
                            onClick={() =>
                                window.open('/home/excellent-design')
                            }>
                            查看更多作品
                        </div>
                    </div>
                </div>
                <div className="section-two">
                    <div className="sub-content">
                        <div className="large-title">
                            {intl.get(
                                'landingPage.intelligentDesign.message60'
                            )}
                        </div>
                        <div className="sub-title">
                            {intl.get(
                                'landingPage.intelligentDesign.message61'
                            )}
                        </div>
                        <div className="feature-switch-wrap">
                            <div
                                className={`feature-tab-bar ${
                                    showTabScrollLeft ? 'has-scroll-left' : ''
                                } ${
                                    showTabScrollRight ? 'has-scroll-right' : ''
                                }`}>
                                {showTabScrollLeft && (
                                    <>
                                        <button
                                            type="button"
                                            className="feature-tab-scroll-btn feature-tab-scroll-btn--left"
                                            onClick={scrollFeatureTabsLeft}
                                            aria-label="向左滚动">
                                            <img
                                                src={chevronLeftIcon}
                                                alt=""
                                                className="feature-tab-scroll-icon"
                                            />
                                        </button>
                                        <div className="feature-tab-fade feature-tab-fade--left" />
                                    </>
                                )}
                                <div
                                    className="feature-tab-list"
                                    ref={featureTabListRef}
                                    onScroll={updateFeatureTabScrollState}>
                                    {FEATURE_LIST.map((v, index) => (
                                        <div
                                            className={`feature-tab-btn ${
                                                activeFeatureIndex === index
                                                    ? 'active'
                                                    : ''
                                            }`}
                                            key={index}
                                            onClick={() =>
                                                setActiveFeatureIndex(index)
                                            }>
                                            {v.title}
                                        </div>
                                    ))}
                                </div>
                                {showTabScrollRight && (
                                    <>
                                        <div className="feature-tab-fade feature-tab-fade--right" />
                                        <button
                                            type="button"
                                            className="feature-tab-scroll-btn feature-tab-scroll-btn--right"
                                            onClick={scrollFeatureTabsRight}
                                            aria-label="向右滚动">
                                            <img
                                                src={chevronRightIcon}
                                                alt=""
                                                className="feature-tab-scroll-icon"
                                            />
                                        </button>
                                    </>
                                )}
                            </div>
                            <div className="feature-panel">
                                <img
                                    className="feature-panel-bg"
                                    src={activeFeature.img}
                                    alt={activeFeature.title}
                                />
                                <div className="feature-panel-left">
                                    <div className="content">
                                        <div className="title">
                                            {activeFeature.title}
                                        </div>
                                        <div className="sub-title-wrap">
                                            {activeFeature.subTitle.map(
                                                (item, idx) => (
                                                    <div
                                                        className="subTitle"
                                                        key={idx}>
                                                        {item}
                                                    </div>
                                                )
                                            )}
                                        </div>
                                        <div className="icon-wrap">
                                            {activeFeature.icon &&
                                                activeFeature.icon.map(
                                                    (item, idx) => (
                                                        <div
                                                            className="icon-item"
                                                            key={idx}>
                                                            <img
                                                                src={
                                                                    item.img
                                                                }></img>
                                                            <div className="icon-text">
                                                                {item.text}
                                                            </div>
                                                        </div>
                                                    )
                                                )}
                                            {activeFeature.linkText && (
                                                <a
                                                    href="/landing/ceiling"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="feature-link">
                                                    {activeFeature.linkText}
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section-one">
                    <div className="sub-content">
                        <div className="large-title">
                            {intl.get(
                                'landingPage.intelligentDesign.message56'
                            )}
                        </div>
                        <div className="sub-title">
                            {intl.get(
                                'landingPage.intelligentDesign.message57'
                            )}
                        </div>
                        <div className="card-wrap">
                            {SESSION_ONE_LIST.map((v, index) => (
                                <div
                                    key={index}
                                    className="card"
                                    style={{
                                        backgroundImage: `url(${v.img})`,
                                    }}>
                                    <div className="card-content">
                                        <div className="card-title">
                                            <div style={{ display: 'none' }}>
                                                {intl.get(
                                                    'landingPage.intelligentDesign.message58'
                                                )}
                                            </div>
                                            {v.title}
                                        </div>
                                        <div className="card-subTitle">
                                            <div style={{ display: 'none' }}>
                                                {intl.get(
                                                    'landingPage.intelligentDesign.message59'
                                                )}
                                            </div>
                                            {v.subTitle}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="section-four">
                    <div className="sub-content">
                        <div className="large-title">
                            {intl.get(
                                'landingPage.intelligentDesign.message69'
                            )}
                        </div>
                        <div className="sub-title">
                            {intl.get(
                                'landingPage.intelligentDesign.message70'
                            )}
                        </div>
                        <Logoes />
                    </div>
                </div>
                <div className="about-foxit">
                    <AboutFoxit
                        middle={
                            <div className="join-us middle-top">
                                <div className="join-us__title">
                                    {intl.get(
                                        'landingPage.intelligentDesign.message71'
                                    )}
                                </div>
                                <div className="operate-btns">
                                    <a
                                        style={{ marginLeft: '6px' }}
                                        href={downloadUrl}
                                        download
                                        rel="nofollow">
                                        <Button
                                            type="primary"
                                            shape="round"
                                            size={'large'}>
                                            {intl.get(
                                                'landingPage.intelligentDesign.message72'
                                            )}
                                        </Button>
                                    </a>

                                    {/* <Button shape="round" size={'large'}>
                                    商务合作
                                </Button> */}
                                </div>
                            </div>
                        }
                    />
                </div>

                <input
                    hidden
                    type="range"
                    name=""
                    id="range"
                    min="0"
                    max="100"></input>
            </div>
        );
    })
);
